import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { convertSymbolCodes } from "../../../Utils/utils";
import useSeo from "../../../hooks/useSeo";
import CitizenCharterTab from "./CitizenCharterTab";
import LiaisonOfficerTab from "./LiaisonOfficerTab";
import usePageVisitTracker from "../../../hooks/usePageVisitTracker";
import ComprehensiveGuidelinesTab from "./ComperhensiveGuidelinesTab";

const CitizenCharterPage = () => {
  const [activeTab, setActiveTab] = useState("Liaison Officer");
  const { getText } = useLanguageTranslation();
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });
  usePageVisitTracker();

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        titleTwo={convertSymbolCodes(innerBannerTitle)}
        title={getText("About Us", "हमारे संबंध में")}
        titleLink="/about-us/citizen-charter"
        levelTwo={true}
        levelThree={false}
        isActive={convertSymbolCodes(innerBannerTitle)}
      />
      <div className="inner-container">
        <div className="container">
          {/* <PageLastUpdated lastUpdatedOn={lastUpdatedOn} /> */}
          <div className="row mt-2">
            <div className="col-12 col-sm-12 col-md-3 col-lg-3 print-left">
              <div className="innleft_section">
                <ul className="menu nav nav-pills flex-column">
                  <li className="nav-item">
                    <a
                      href="#"
                      role="tab"
                      className={`nav-link ${
                        activeTab === "Liaison Officer" ? "active" : ""
                      }`}
                      aria-selected={activeTab === "Liaison Officer"}
                      aria-controls="liaison-content"
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab("Liaison Officer");
                      }}
                    >
                      <div>{getText("Liaison Officer", "संपर्क अधिकारी")}</div>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      href="#"
                      role="tab"
                      className={`nav-link ${
                        activeTab === "Citizen's Charter" ? "active" : ""
                      }`}
                      aria-selected={activeTab === "Citizen's Charter"}
                      aria-controls="charter-content"
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab("Citizen's Charter");
                      }}
                    >
                      <div>
                        {getText("Citizen's Charter", "सिटिजन्स चार्टर")}
                      </div>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      href="#"
                      role="tab"
                      className={`nav-link ${
                        activeTab === "comprehensive-guideline" ? "active" : ""
                      }`}
                      aria-selected={activeTab === "comprehensive-guideline"}
                      aria-controls="charter-content"
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveTab("comprehensive-guideline");
                      }}
                    >
                      <div>
                        {getText(
                          "Comprehensive guideline on Public Grievance ",
                          "जन शिकायत पर व्यापक दिशानिर्देश ",
                        )}
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-9 col-lg-9 print-right">
              {activeTab === "Citizen's Charter" && <CitizenCharterTab />}
              {activeTab === "Liaison Officer" && <LiaisonOfficerTab />}
              {activeTab === "comprehensive-guideline" && (
                <ComprehensiveGuidelinesTab />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CitizenCharterPage;
